import React from "react";
import { useTranslation } from "react-i18next";
import { BailRightFeedback } from "types";
import { feedbackIcon } from "utils/constant";

type Props = {
  coordinator_feedbacks: BailRightFeedback[];
};

const BailRightFeedbackSection: React.FC<Props> = ({
  coordinator_feedbacks,
}) => {
  const { t } = useTranslation();

  return (
    <div className="ml-6">
      <h1 className="text-black font-semibold text-base flex flex-row gap-2">
        {feedbackIcon} {t("feedback_section_title")}
      </h1>
      <div className="flex flex-col gap-4 mt-4 justify-between h-[70vh] w-full">
        <div className="flex flex-col overflow-y-auto gap-2">
          <div className="">
            {coordinator_feedbacks?.length === 0 && (
              <p className="text-gray-500 text-sm">
                {t("no_feedbacks_available")}
              </p>
            )}
            {coordinator_feedbacks?.map((feedback, index) => (
              <div
                key={index}
                className={`${
                  index % 2 === 0 ? "bg-white" : "bg-gray-100"
                } px-6 py-4 rounded-md shadow-sm mb-4`}
                style={{
                  overflowWrap: "break-word",
                }}
              >
                <div className="flex justify-between items-center">
                  <p className="text-xs font-medium text-red-600">
                    {t("commented_date")}
                  </p>
                  <p className="text-xs text-gray-700">
                    {feedback?.created_at &&
                      new Date(feedback?.created_at).toLocaleString()}
                  </p>
                </div>

                <div className="mt-3">
                  <p className="w-[450px] text-sm text-gray-800 whitespace-pre-line">
                    {feedback?.comment}
                  </p>
                </div>

                <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                  <p className="text-xs text-gray-700">
                    <span className="font-semibold">{t("by_label")}:</span>{" "}
                    {feedback?.coordinator_fullname}
                  </p>
                  <p className="text-xs text-gray-700">
                    <span className="font-semibold">
                      {t("decision_label")}:
                    </span>{" "}
                    <span
                      className={`px-2 py-1 rounded-md text-white text-xs font-semibold ${
                        feedback?.decision === "approve"
                          ? "bg-green-500"
                          : feedback?.decision === "respond_back"
                            ? "bg-red-500"
                            : "bg-yellow-500"
                      }`}
                    >
                      {feedback?.decision === "approve"
                        ? t("decision_approved")
                        : t("decision_respond_back")}
                    </span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BailRightFeedbackSection;
